import {
    AbstractControl, Validator, NG_ASYNC_VALIDATORS, ValidatorFn
} from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CommonHttpService } from '../services/http.service';
import { Response } from '@angular/http';
import { ClientModel } from '../models/client.model';

@Directive({
    selector: '[existsDocument1]',
    providers: [{
        provide: NG_ASYNC_VALIDATORS,
        useExisting: ExistsDocument1ValidatorDirective,
        multi: true
    }]
})
export class ExistsDocument1ValidatorDirective implements Validator {
    @Input() existsDocument1: string;

    constructor(
        protected http: CommonHttpService
    ) { }

    validate(control: AbstractControl): {[key: string]: any} {
        return valueExistsValidatorFn(
            this.http,
            control.value.replace(/\D/g, '')
        );
    }
}
export function valueExistsValidatorFn(
    http: CommonHttpService,
    document1: string
): Observable<any> {
    return new Observable(observable => {
        http.get(
            `/ecommerce/identification/exists/document1?value=${document1}`
        ).subscribe((res: Response) => {
            let exists = null;
            const json = res.json();
            if (res.status === 200 && json.exists) {
                exists = {'existsDocument1': true, 'existentUser': json.data};
            }
            observable.next(exists);
            observable.complete();
        }, () => {
            observable.next(null);
            observable.complete();
        });
    });
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/validators/exists-document1.directive.ts